import PubSub from "underpub-js";

var TableListItem = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-TableListItem',
	};

	$.extend(true, this.options, options);

};

TableListItem.prototype.init = function() {

	var self = this;

};

export default TableListItem;
